import { FC } from 'react';
import { Breadcrumb, Card, PageHeader } from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";
import CategoryForm from '../components/forms/category-form';

const CategoriesFormRoute: FC = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const id = searchParams.get('id')
  return (
    <>
      <PageHeader
        title="فرم دسته بندی"
        style={{ padding: " 16px 0" }}
        onBack={() => navigate(-1)}
      />
      <Card >
        <CategoryForm id={id} />
      </Card>
    </>
  );
}

export default CategoriesFormRoute;
